import HotlineNumberWithIcon from './hotline-number-with-icon/component.vue';
import FakeCountdownTime from './fake-countdown-time/component.vue';
import { mapActions } from 'vuex';

export default {
  name: 'page-calling',
  props: ['hotlineDetails', 'hotlineDestinationNumber', 'widgetStyle'],
  components: {
    'hotline-number-with-icon': HotlineNumberWithIcon,
    'fake-countdown-time': FakeCountdownTime,
  },
  methods: {
    ...mapActions(['cancelCallRequest', 'showErrorMessage']),
  },
  sockets: {
    HOTLINE_CALL_REQUEST_CANCELLED() {
      this.showErrorMessage('Połączenie zostało anulowane');
    },
  },
};
